
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Hook para alterar o título da página dinamicamente.
 * @param {string} title - O novo título da página.
 */
export const usePageTitle = (title: string) => {
    useEffect(() => {
        const originalTitle = document.title; // Armazena o título original da página
        document.title = title; // Define o novo título

        // Limpeza: volta para o título original ao desmontar o componente
        return () => {
            document.title = originalTitle;
        };
    }, [title]); // Reexecuta quando o título muda
};

export function useQueryParams<T extends Record<string, string>>() {
    const query = new URLSearchParams(useLocation().search);
    const params: Partial<T> = {};
  
    query.forEach((value, key) => {
      params[key as keyof T] = value as any;
    });
  
    return params as T;
  }
